var _use, _symbol;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAwsKms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 74.375 85",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ALKJUY83Uh",
    x: 2.188,
    y: 2.5
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "ALKJUY83Uh",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.78 25.015l-7.749-1.108V13.246l10.469 2.75-2.72 9.019z",
    fill: "#759c3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.314 26.385L0 27.687V16.57l7.031-3.324 8.283 13.139zm39.916-1.37l7.749-1.108V13.246l-10.48 2.75 2.73 9.019z",
    fill: "#4b612c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.686 26.385L70 27.687V16.57l-7.02-3.324-8.293 13.139z",
    fill: "#759c3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.21 6.997l-8.016 15.481h0L0 25.938v9.883l14.123 28.708L35 80l14.503-17.162V14.84L35 0 20.21 6.997z",
    fill: "#4b612c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 35.821v-9.883l-12.193-3.46h0L49.79 6.997 35 0v15.996 48.008V80l20.877-15.471L70 35.821z",
    fill: "#759c3e"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsKms);
export default __webpack_public_path__ + "static/media/aws-kms.f2d57e2027e9a2680dfee964d885184d.svg";
export { ForwardRef as ReactComponent };